import { render, staticRenderFns } from "./modalCrearImpuesto.vue?vue&type=template&id=57487a0f&"
import script from "./modalCrearImpuesto.vue?vue&type=script&lang=js&"
export * from "./modalCrearImpuesto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports